import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {BranchesDialogService} from "../../../branches/services/branches-dialogs-service.service";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {RouteRequestsService} from "../../../routes/services/routes-requests.service";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {LeanPlanningAlertsService} from "../../services/lean-planning-alerts.factory";
import {LeanPlanningDialogService} from "../../services/lean-planning-dialogs-service.factory";
import {LeanPlanningService} from "../../services/lean-planning-service.service";
import {LeanPlanningRequestsService} from "../../services/plan-requests.factory";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ResizerService} from "../../../commons/services/resizer.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {TasksFacadeService} from "../../../tasks/angular/services/tasks-facade.service";
import {Subscription} from "rxjs";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {GroupModel} from "../../../groups/models/group.model";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {ServiceAreaRequests} from "../../../service-areas/services/service-area-requests.service";
import {SortType} from "../../../commons/types/sort.type";
import {RoutesFacadeService} from "../../angular/services/routes-facade.service";
import {RouteModel} from "../../../routes/models/route.model";
import {RouteTotalStatusEnum} from "../../types/route-total-status.enum";
import {SupplyResourceEnum} from "../../types/supply-resource.enum";
import {ExportType} from "../../../commons/types/export.type";
import {EXPORT_CSV_SIZE_LIMIT, EXPORT_EXCEL_SIZE_LIMIT} from "../../../commons/angular/constants/commons";
import {RouteExportRowType} from "../../../routes/enums/route-export-row.type";
import {
  ResourceAllocationTimeWindowExtModel
} from "../../../resources/models/resource-allocation-time-window-ext.model";
import {ChangeRouteResourceQueryModelModel} from "../../../routes/models/change-route-resource-query-model.model";

export class PlanningRoutesTestComponent implements IController {

  serviceAreasMap: any;
  dateRangeTemplateType: DateRangeTemplateType;
  ids: string[];
  project: any;
  from: any;
  to: any;
  routeStatuses: any;
  serviceAreaIds: any;
  agentIds: any;
  agentSkills: string[];
  resourceIds: any;
  agentScheduleIds: any;
  branchIds: any;
  groupIds: string[];
  groupsBranchIds: string[];
  branchMode: any;
  selectedGroup: any;
  selectedQuickFilterId: string;

  public serviceAreasRef: any;
  public siteId: any;
  public tasksRef: any;
  public loading: boolean = false;
  public timelineZoom: any = undefined;
  public routesMenu: any = {
    deleteEnabled: true,
    resetEnabled: true
  };
  public totals: any = undefined;
  public totalSelectedRoutesCount: any = undefined;
  public expandedRoutes: any = [];
  public expandedRoutesTasks: any = []
  public suggestedServices: any = [];
  public selectedIds: any = [];
  public excludeMode: boolean = false;
  public routeGroupKeys: any;
  public expendedRoutesServiceAreas: any = [];
  public filterConfig: any;
  public isMouseHorizontalDown: boolean = false;
  public isMouseVerticalDown: boolean = false;
  public showMap: boolean = true;
  public isMobile: boolean;
  public flexLeft: any;
  public flexRight: any;
  public selectedTaskId: any;
  public timeSelectEnabled: any;
  public routesRef: any;
  public pushesTimeoutRef: any;
  public maxUserIdleTimeMinutes: number;
  public pageName: string;
  public tasksSubscription: Subscription;
  public sortTypesValues: any;
  public selectedSortValue: any;
  public loadLimit: number = 15;
  public routesSubscription: Subscription;
  public isLoadingRoutesSubscription: Subscription;
  public routes: RouteModel[];
  public isLoadingRoutes: boolean;
  public supplyResourceSource: SupplyResourceEnum;

  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $state, private routesService: RoutesService, private leanPlanningRequestsService: LeanPlanningRequestsService, private routeRequestsService: RouteRequestsService,
              private splitService: SplitService, private TimelineService, private commonsDialogService: CommonsDialogService, private resizerService: ResizerService,
              private $timeout: ITimeoutService, private tasksService: TasksService, private commonsService: CommonsService, private $groups, private routesFacadeService: RoutesFacadeService,
              private leanPlanningConstants, private moment, private branchesDialogService: BranchesDialogService, private leanPlanningAlertsService: LeanPlanningAlertsService,
              private $log, private confirmDialogService: ConfirmDialogService, private leanPlanningDialogService: LeanPlanningDialogService, private $serviceArea, private $task, private $mdMedia,
              private $route, private leanPlanningService: LeanPlanningService, private commonsConstants, private $delivery, private deliveriesService: DeliveriesService,
              private tasksFacadeService: TasksFacadeService, private viewFilterSettingsService: ViewFilterSettingsService, private serviceAreaRequests: ServiceAreaRequests) {
    this.serviceAreasRef = this.$serviceArea();
    this.siteId = this.splitService.getSiteId();
    // this.tasksRef = this.$task();
    // this.routesRef = this.$route();
    this.routeGroupKeys = this.leanPlanningConstants.routeGroupKeys;
    this.maxUserIdleTimeMinutes = this.splitService.maxUserIdleTimeMinutes();
  }

  $onInit() {

    this.sortTypesValues = {
      sortNotBefore: {asc: 'notBefore,asc', desc: 'notBefore,desc'},
      sortLogisticVehiclePlateNumber: {
        asc: 'planningResource.mainLogisticsVehicleReference.licensePlateNumber,asc',
        desc: 'planningResource.mainLogisticsVehicleReference.licensePlateNumber,desc'
      },
    };

    this.pageName = this.$state.current.name;
    this.filterConfig = {
      routeIds: this.ids,
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      excludeIdsMap: {
        [SiteFiltersType.branchIds]: this.groupsBranchIds || []
      },
      queryString: undefined,
      range: {dateStart: undefined, dateEnd: undefined},
      tags: this.project ? [this.project.id] : undefined,
      includeFilters: undefined,
      settings: this.splitService.getSitePlanningRoutesSettings()
    }

    this.filterConfig.bringozFilters = {
      dateRangeTemplateType: this.dateRangeTemplateType,
      routeStatuses: this.routeStatuses,
      branchIds: this.branchIds,
      groupIds: this.groupIds,
      serviceAreaIds: this.serviceAreaIds,
      agentIds: this.agentIds,
      agentSkills: this.agentSkills,
      resourceIds: this.resourceIds || [],
      agentScheduleIds: this.agentScheduleIds || []
    }


    this.filterConfig.includeFilters = [SiteFiltersType.agentIds, SiteFiltersType.agentSkills, SiteFiltersType.serviceAreaIds, SiteFiltersType.branchIds, SiteFiltersType.groupIds, SiteFiltersType.resourceIds,
      SiteFiltersType.agentScheduleIds, SiteFiltersType.dateRangeTemplateType, SiteFiltersType.routeStatuses];

    this.isMouseHorizontalDown = false;
    this.isMouseVerticalDown = false;

    this.isMobile = !this.$mdMedia('gt-xs');

    if (!!this.isMobile) {
      this.showMap = false;
    }


    // this.flexLeft = $mdMedia('gt-sm') ? '65%' : '100%';
    // this.flexRight = $mdMedia('gt-sm') ? '35%' : '100%';

    var range = (this.from && this.to) ?
      {dateStart: this.from, dateEnd: this.to} :
      (this.project ? undefined : this.dateRangeTimeFiltersService.today());

    if (!!range) {
      this._setRange(range);
      this._updateStateParams();
    }

    this._getRoutes();
    this._setTotals();

    this.routesFacadeService.subscribeToChannels();

    this.routesSubscription = this.routesFacadeService.selectInfiniteScrollEntities().subscribe(routes => {

      this.routes = angular.copy(routes);

      const expandedRoutesToUpdate = [];
      let taskIdsToAdd = [];
      let taskIdsToRemove = [];

      _.forEach(routes, (updatedRoute: RouteModel) => {
        // Routes - Remove / Update
        const currentRouteRef = _.find(this.expandedRoutes, (route) => {
          return route.id === updatedRoute.id;
        })
        if (!!currentRouteRef) {
          expandedRoutesToUpdate.push(updatedRoute);
          taskIdsToAdd = _.difference(updatedRoute.taskIdListExt, currentRouteRef.taskIdListExt);
          taskIdsToRemove = _.difference(currentRouteRef.taskIdListExt, updatedRoute.taskIdListExt);
        }

        if (expandedRoutesToUpdate.length) {
          this.expandedRoutes = _.uniqBy(_.concat(expandedRoutesToUpdate, this.expandedRoutes), 'id');
        }

        if (taskIdsToAdd.length) {
          this.tasksFacadeService.getByIds(taskIdsToAdd);
        }

        if (taskIdsToRemove.length) {
          this.tasksFacadeService.removeByIds(taskIdsToRemove);
        }

      })

      this.$timeout(() => {
      }, 0)
    });


    this.isLoadingRoutesSubscription = this.routesFacadeService.selectIsLoading().subscribe((isLoading) => {
      this.isLoadingRoutes = isLoading;
      this.$timeout(() => {
      }, 0)
    });


    // Routes Change Event Listener
    // this.routesRef.$subscribeToChannelEvents((updatedRoutes, action) => {
    //
    //   const expandedRoutesToUpdate = [];
    //   // const expandedRoutesToRemove = [];
    //
    //   let taskIdsToAdd = [];
    //   let taskIdsToRemove = [];
    //
    //   const currentRouteIds = _.map(this.expandedRoutes, 'id');
    //
    //   _.forEach(updatedRoutes, (updatedRoute) => {
    //     // Routes - Remove / Update
    //     if ((action === 'changed' || action === 'partialChanged') && _.includes(currentRouteIds, updatedRoute.id)) {
    //       const currentRouteRef = _.find(this.expandedRoutes, (route) => {
    //         return route.id === updatedRoute.id;
    //       })
    //       if (!!currentRouteRef) {
    //         expandedRoutesToUpdate.push(updatedRoute);
    //         taskIdsToAdd = _.difference(updatedRoute.taskIdListExt, currentRouteRef.taskIdListExt);
    //         taskIdsToRemove = _.difference(currentRouteRef.taskIdListExt, updatedRoute.taskIdListExt);
    //       }
    //     }
    //
    //     if (expandedRoutesToUpdate.length) {
    //       this.expandedRoutes = _.uniqBy(_.concat(expandedRoutesToUpdate, this.expandedRoutes), 'id');
    //     }
    //
    //     if (taskIdsToAdd.length) {
    //       this.tasksFacadeService.getByIds(taskIdsToAdd);
    //     }
    //
    //     if (taskIdsToRemove.length) {
    //       this.tasksFacadeService.removeByIds(taskIdsToRemove);
    //     }
    //
    //   })
    // });

    // Tasks Change Event Listener
    // this.tasksRef.$subscribeToChannelEvents((updatedTasks, action) => {
    //   if (action === 'changed' || action === 'partialChanged') {
    //     const updatedTasksIds = _.flatMap(updatedTasks, 'id');
    //     const tasksToUpdate = [];
    //
    //     _.forEach(updatedTasks, (t) => {
    //       const taskIndexToUpdate = _.findIndex(this.expandedRoutesTasks, (t: any) => {
    //         return _.includes(updatedTasksIds, t.id);
    //       });
    //
    //       if (taskIndexToUpdate > -1) {
    //         tasksToUpdate.push(t);
    //       }
    //     })
    //
    //     if (tasksToUpdate.length) {
    //       this.expandedRoutesTasks = _.uniqBy(_.concat(tasksToUpdate, this.expandedRoutesTasks), 'id');
    //     }
    //
    //   }
    // });

    this.tasksFacadeService.subscribeToChannels();

    this.tasksSubscription = this.tasksFacadeService.selectAll()
      .subscribe((tasks: TaskModel[]) => {
        this.expandedRoutesTasks = tasks;
        this.$timeout(0).then(() => {
        });
      })

    // Bind User Event Listeners
    this.commonsService.bindUserEvents((event) => {
      if (!!this.pushesTimeoutRef) {
        this._initPushesTimer();
      }
    })

    this._initPushesTimer();

  };

  $doCheck() {
    this.isMobile = !this.$mdMedia('gt-xs');
    this.flexLeft = this.$mdMedia('gt-sm') ? '65%' : '100%';
    this.flexRight = this.$mdMedia('gt-sm') ? '35%' : '100%';
  };

  $onDestroy() {
    // this.routesRef.$destroyChannel();
    // this.tasksRef.$destroyChannel();

    this.routesFacadeService.clearStore();
    this.routesSubscription?.unsubscribe();
    this.isLoadingRoutesSubscription?.unsubscribe();

    this._destroyPushesTimer();
  }

  getRouteTotals() {
    if (!!this.totals) {
      if (!this.filterConfig.bringozFilters.routeStatuses?.length) {
        return this.totals.total
      } else {
        let totals = 0;
        this.filterConfig.bringozFilters.routeStatuses.forEach((s) => {
          totals += this.totals[RouteTotalStatusEnum[s]];
        })

        return totals;
      }
    }
  }

  onDividerMove(event) {
    if (this.isMouseHorizontalDown) {
      this.resizerService.onHorizontalMove(event)
        .then((flex) => {
          this.flexLeft = flex.left;
          this.flexRight = flex.right;
        });
    }
    // if (this.isMouseVerticalDown) {
    //   resizerService.onVerticalMove(event)
    //   .then(function (flex) {
    //
    //   });
    // }
  }

  onDividerMoveDone() {
    this.isMouseHorizontalDown = false;
    this.isMouseVerticalDown = false;
  }

  submitQuery(query) {
    this.filterConfig.queryString = query;

    if (!!this.filterConfig.routeIds) {
      this.filterConfig.routeIds = undefined;
    }

    this._setTotals();
    this._getRoutes();
  }


  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      if (quickFilter.settings.groupIds?.length) {
        this.$groups().$asyncValues(quickFilter.settings.groupIds)
          .then((groups) => {
            let groupsBranchIds = [];
            groups.forEach((g: GroupModel) => {
              if (g.branchIds?.length) {
                groupsBranchIds = groupsBranchIds.concat(g.branchIds)
              }
            });
            this.filterConfig.excludeIdsMap[SiteFiltersType.branchIds] = groupsBranchIds;
            quickFilter.settings[SiteFiltersType.branchIds] = _.uniq(groupsBranchIds);
            this.onFiltersChange(quickFilter.settings, quickFilter);
          })
      } else {
        this.onFiltersChange(quickFilter.settings, quickFilter);
      }
    } else {
      const filters = angular.copy(this.filterConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {

    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.filterConfig.bringozFilters = filters;

    if (!!this.filterConfig.routeIds) {
      this.filterConfig.routeIds = undefined;
    }

    if (!!filters.dateRangeTemplateType) {
      this.filterConfig.range = this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    }

    this._updateStateParams();
    this._setTotals();
    this._getRoutes();
  }


  onRangeChanged(range) {
    if (range &&
      (!_.isEqual(range.dateStart, this.filterConfig.range.dateStart) ||
        !_.isEqual(range.dateEnd, this.filterConfig.range.dateEnd))) {

      if (!!this.filterConfig.routeIds) {
        this.filterConfig.routeIds = undefined;
      }

      if (this.selectedQuickFilterId && range?.type !== this.filterConfig.bringozFilters.dateRangeTemplateType) {
        this.selectedQuickFilterId = undefined;
      }

      this.filterConfig.bringozFilters.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;

      this._setRange(range)
      this._setTotals();
      this._getRoutes();
    }
  }

  onResetRoute(routeId) {
    this.confirmDialogService.confirm('Reset Route', 'Are you sure you want to reset?')
      .then(() => {
        this._resetRoutes([routeId], false);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onResetRoutes(ids) {
    this.confirmDialogService.confirm('Reset Routes', 'Are you sure you want to reset?')
      .then(() => {
        this._resetRoutes(this.selectedIds, this.excludeMode);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onAssignRoutesToAttachedAgent(ids) {
    this.loading = true;
    this.routeRequestsService.assignRoutesToAttachedAgents(
      this.excludeMode ? [] : this.selectedIds,
      this.filterConfig.branchIds,
      this.excludeMode ? this.selectedIds : [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.agentSkills,
      this.filterConfig.queryString,
      this.filterConfig.bringozFilters.serviceAreaIds,
      this.filterConfig.bringozFilters.routeStatuses,
      this.filterConfig.bringozFilters.resourceIds.concat(this.filterConfig.bringozFilters.agentScheduleIds),
      this.filterConfig.tags
    )
      .then(() => {
        this.leanPlanningAlertsService.assignSuccess();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.assignError();
        this.$log.error('Failed to assign route to driver @planningRoutesTable@onAssignRoute', error)
      })
      .finally(() => {
        this.loading = false;
        this.resetSelection();
      })
  }

  onTimelineZoom(isZoomIn) {
    this.timelineZoom = isZoomIn;
  }

  onZoomChanged() {
    this.timelineZoom = undefined;
  }

  onMoveTask(serviceId, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds) {
    const payload = this.TimelineService.getMovedTaskPayload([serviceId],
      fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);


    this.loading = true;
    this.leanPlanningRequestsService.editRoutes(payload)
      .then((updatedRoutes) => {
        // const expandedRoutesCopy = angular.copy(this.expandedRoutes);
        // _.forEach(updatedRoutes, (r) => {
        //   const expandedRouteIndex = _.findIndex(this.expandedRoutes, (exRoute: any) => {
        //     return r.rid === exRoute.rid;
        //   })
        //   if (expandedRouteIndex > -1) {
        //     expandedRoutesCopy[expandedRouteIndex] = r;
        //   }
        // })
        // this.expandedRoutes = expandedRoutesCopy;
        //Updating From Push
        this.leanPlanningAlertsService.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error(
            'Failed to change route itinerary @planningRoute@onRouteOrderChange',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onReoptimizeRoute(routeId) {
    this.loading = true;
    this.leanPlanningRequestsService.optimizeRoute(routeId)
      .then((optimizedRoute) => {
        //Updating From Push
        this.leanPlanningAlertsService.reOptimizeSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.reOptimizeError();
          this.$log.error('Failed to Optimize route @planningRoute@onRecalcRoute', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onMergeRoutes(ids) {
    this.confirmDialogService.confirm('Merge Routes', 'Are you sure you want to merge these routes?')
      .then(() => {
        this.loading = true;
        return this.routeRequestsService.mergeRoutes(
          this.excludeMode ? [] : this.selectedIds,
          this.filterConfig.branchIds,
          this.excludeMode ? this.selectedIds : [],
          this.filterConfig.range.dateStart,
          this.filterConfig.range.dateEnd,
          this.filterConfig.agentSkills,
          this.filterConfig.queryString,
          this.filterConfig.bringozFilters.serviceAreaIds,
          this.filterConfig.bringozFilters.routeStatuses,
          this.filterConfig.bringozFilters.resourceIds.concat(this.filterConfig.bringozFilters.agentScheduleIds),
          this.filterConfig.tags
        )
      })
      .then(() => {
        this.leanPlanningAlertsService.mergeRoutesSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.mergeRoutesError();
          this.$log.error('Failed to merge routes @planningRoutes@onMergeRoutes', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onDeleteRoute(routeId, event) {
    this.confirmDialogService.confirm('Delete Route', 'Are you sure you want to delete this route?', event)
      .then(() => {
        this._deleteRoutes([routeId], false);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDeleteRoutes(ids) {
    this.confirmDialogService.confirm('Delete Routes', 'Are you sure you want to delete these routes?')
      .then(() => {
        this._deleteRoutes(ids, this.excludeMode);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onUpdateBranchesRoutes(ids, event) {
    this.branchesDialogService.branchesSelect(event)
      .then((branchIds) => {
        this._updateBranchesRoutes(branchIds);
      })
  }

  onUpdateBranches(route) {
    this.branchesDialogService.branchesSelect(event, undefined, route.branchIds)
      .then((branchIds) => {
        this._updateBranchesRoute(route.id, branchIds);
      })
  }

  onTaskSelection(taskId) {
    this.selectedTaskId = taskId;
  }

  onSelectRoutesChanged(selectedIds, excludeMode) {
    this.selectedIds = selectedIds;
    this.excludeMode = excludeMode;

    // if (this.excludeMode && (this.selectedIds.length === this.totalSelectedRoutesCount)) {
    //   this.excludeMode = false;
    //   this.selectedIds = [];
    // }

    this.$timeout(0).then(() => {
    });
  }

  onToggleShowRoute(route) {
    const mapRouteIndex = _.findIndex(this.expandedRoutes, (expendedRoute: any) => {
      return expendedRoute.rid === route.rid;
    })
    if (mapRouteIndex === -1) {
      this._addExpandedRoutes([route.rid]);
    } else {
      this._removeExpandedRoutes([route.rid]);
    }
  }

  fetchNext() {
    if (this.isLoadingRoutes) return;
    this.routesFacadeService.fetchNext(this._getRoutesQuery(), true);
  }

  // onToggleBlockRoute(route) {
  //   this.leanPlanningService.editBlockedState(route.id, !route.isBlockedByUser)
  //     .then((updatedRoute) => {
  //       const expandedRouteIndex = _.findIndex(this.expandedRoutes, (r: any) => {
  //         return r.id === updatedRoute.id;
  //       })
  //       if (expandedRouteIndex > -1) {
  //         const expandedRoutesCopy = angular.copy(this.expandedRoutes);
  //         expandedRoutesCopy[expandedRouteIndex] = updatedRoute;
  //
  //         this.expandedRoutes = expandedRoutesCopy;
  //         this.expandedRoutesTasks = _.uniqBy(_.concat(updatedRoute.taskListExt, this.expandedRoutesTasks), 'id');
  //       }
  //     })
  // }

  onUpdateIsBlockedByUser(routeId, isBlockedByUser) {
    this.leanPlanningService.editBlockedState(routeId, isBlockedByUser)
      .then((updatedRoute: any) => {
        const expandedRouteIndex = _.findIndex(this.expandedRoutes, (r: any) => {
          return r.id === updatedRoute.id;
        })
        if (expandedRouteIndex > -1) {
          const expandedRoutesCopy = angular.copy(this.expandedRoutes);
          expandedRoutesCopy[expandedRouteIndex] = updatedRoute;

          this.expandedRoutes = expandedRoutesCopy;
          this.tasksFacadeService.removeByIds(updatedRoute.taskIdListExt);
          this.tasksFacadeService.setMany(updatedRoute.taskListExt);
          // this.expandedRoutesTasks = _.uniqBy(_.concat(updatedRoute.taskListExt, this.expandedRoutesTasks), 'id');
        }
      })
  }

  resetSelection(ids?: any) {
    this.expandedRoutes = ids ? _.filter(this.expandedRoutes, (route) => {
      return !_.includes(ids, route.rid);
    }) : [];
    this.selectedIds = ids ? _.filter(this.selectedIds, (id) => {
      return !_.includes(ids, id);
    }) : [];
    this.expendedRoutesServiceAreas = ids ? _.filter(this.expendedRoutesServiceAreas, (serviceArea) => {
      const connectedRoute = _.find(this.expandedRoutes, (r) => {
        const areaIdList = _.get(r, 'serviceAreaIdList', []);
        return _.includes(areaIdList, serviceArea.areaId)
      })
      return !!connectedRoute;
    }) : [];
    this.excludeMode = false;
    this.selectedTaskId = undefined;
  }

  // onChangeServiceAreas(serviceAreas) {
  //   const serviceAreaIds = _.map(serviceAreas, function (serviceArea) {
  //     return serviceArea.areaId;
  //   });
  //
  //   if (!_.isEqual(serviceAreaIds,
  //     this.filterConfig.serviceAreaIds)) {
  //     this.filterConfig.serviceAreaIds = serviceAreaIds;
  //     this.$state.go('.', {areaIds: this.filterConfig.serviceAreaIds}, {reload: false, notify: false});
  //   }
  // }

  // function onShownRouteChanged(deleteIds, updateIds) {
  //   if (deleteIds && deleteIds.length) {
  //     _removeExpandedRoutes(deleteIds);
  //   }
  //   if (updateIds && updateIds.length){
  //     _addExpandedRoutes(updateIds);
  //   }
  // }

  onExport(exportType: RouteExportRowType, event) {

    const selectedStatuses = angular.copy(this.filterConfig.bringozFilters.routeStatuses) || [];
    let limit = 0;

    if (!selectedStatuses?.length) {
      limit = this.totals.total;
    } else {
      selectedStatuses.forEach((s) => {
        const totalGroup =  s.toLowerCase();
        const matchedKey = Object.keys(this.totals).find(
          key => key.toLowerCase() === totalGroup.toLowerCase()
        );
        limit += this.totals[matchedKey];
      })
    }

    let extraText;

    const text = 'Are you sure you want to export?';
    if (limit > EXPORT_CSV_SIZE_LIMIT) {
      extraText = 'EXPORT_INFO_LIMIT';
    }
    this.confirmDialogService.confirmWithInfo('Export', text, extraText, {x: EXPORT_CSV_SIZE_LIMIT}, event)
      .then(() => {
        this._export(exportType);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');

      });

  }

  private _export(exportType: RouteExportRowType) {
    this.routesService.exportRoutes(
      this.excludeMode ? [] : this.selectedIds,
      this.excludeMode ? this.selectedIds : [],
      this.filterConfig.bringozFilters.branchIds,
      this.filterConfig.bringozFilters.serviceAreaIds,
      this.filterConfig.bringozFilters.routeStatuses,
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.queryString,
      this.filterConfig.bringozFilters.agentSkills,
      exportType,
      this.filterConfig.tags,
      this.filterConfig.bringozFilters.resourceIds.concat(this.filterConfig.bringozFilters.agentScheduleIds))
      .then((res) => {
      });
  }

  onExportIntegration() {
    this.routesService.exportIntegrationRoutes(
      this.selectedIds,
      this.filterConfig.bringozFilters.branchIds,
      this.filterConfig.bringozFilters.serviceAreaIds,
      this.filterConfig.bringozFilters.routeStatuses,
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.queryString,
      this.filterConfig.bringozFilters.agentSkills,
      this.filterConfig.tags,
      this.filterConfig.bringozFilters.resourceIds.concat(this.filterConfig.bringozFilters.agentScheduleIds))
      .then((res) => {
      });
  }

  onUpdateResource(route) {
    this.leanPlanningDialogService.updateResource(route)
      .then((payload: {
        allocation: ResourceAllocationTimeWindowExtModel,
        queries: ChangeRouteResourceQueryModelModel
      }) => {
        this._reCreateRoute(route, payload.allocation, payload.queries);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onManageAssistants(route, event?) {
    this.leanPlanningDialogService.manageAssistants(route, event)
      .then((updatedAssistants: string[]) => {
        this._assignAssistant(route.id, updatedAssistants)
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onUpdateLogisticsVehicle(task, route) {
    this.leanPlanningDialogService.onUpdateRouteBoundEquipment(route, _.get(route, 'branchIds'), event)
      .then((payload) => {
        const routeCopy = angular.copy(route);
        routeCopy.planningResource.mainLogisticsVehicleReference = payload.mainLogisticVehicle;
        if (payload.attachedLogisticVehicle) {
          if (!routeCopy.planningResource.attachedLogisticsVehicleReferences) {
            routeCopy.planningResource.attachedLogisticsVehicleReferences = [];
          }
          routeCopy.planningResource.attachedLogisticsVehicleReferences[0] = payload.attachedLogisticVehicle;
        }
        this._updateRoute(routeCopy);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onChangeRouteColor(route) {
    this.commonsDialogService.selectColor(route.color, this.commonsConstants.colorPalletRoutes)
      .then((selectedColor) => {
        const updatedRoute = angular.copy(route);
        updatedRoute.color = selectedColor;
        this._updateRoute(updatedRoute);
      })
  }

  onViewSettingsChange(settings) {
    this.filterConfig.settings = settings;
    this.splitService.setSitePlanningRoutesSettings(settings);
  }

  onAssignRoute(route) {
    this.loading = true;
    this.leanPlanningRequestsService.assignRouteToAgent(route.rid, route.agentId)
      .then(() => {
        this.leanPlanningAlertsService.assignSuccess();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.assignError();
        this.$log.error('Failed to assign route to driver @planningRoutesTable@onAssignRoute', error)
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onRouteReset(route) {
    this.leanPlanningDialogService.routeReset(route)
      .then((payload) => {
        this.loading = true;
        return this.routeRequestsService.resetRoutes(route.rid, undefined, undefined, undefined, undefined, payload.resetOnlyAssignAgentServices);
      })
      .then(() => {
        this.leanPlanningAlertsService.resetSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.resetError();
          this.$log.error('Failed to reset route', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onAssignRouteAndSelectDriver(route, ev?) {
    this.leanPlanningDialogService.manualAssignRoute(ev, route.rid)
      .then((payload) => {
        this.loading = true;
        return this.leanPlanningRequestsService.assignRouteToAgent(route.rid, payload.agentId, payload.assignServices);
        // return RouteRequests.assignRouteToAgent(route.rid, payload.agentId, payload.doForce);
      })
      .then(() => {
        this.leanPlanningAlertsService.assignSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.assignError();
          this.$log.error('Failed to assign route to driver @planningRoutesTable@onAssignRoute', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  handleUnpackedDeliveries(route) {
    this.$delivery.$asyncValues(route.serviceIdList)
      .then((services) => {
        let unpackedDeliveries = [];
        _.forEach(services, (service) => {
          var isUnpacked = this.deliveriesService.isDeliveryUnpacked(service.packageList[0].items);
          if (isUnpacked) {
            unpackedDeliveries.push(service);
          }
        });
        this.onHandleUnpackedDeliveries(route, unpackedDeliveries)
      })
  }

  onHandleUnpackedDeliveries(route, services, event?) {
    this.leanPlanningDialogService.handleUnpackedServices(services, event)
      .then((serviceIdsToRemove) => {
        this.loading = true;
        return this.leanPlanningRequestsService.removeDeliveryFromRoute(serviceIdsToRemove,
          route.rid)
      })
      .then(() => {
        this.leanPlanningAlertsService.removeUnpackedSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.removeUnpackedError();
          this.$log.error(
            'Failed to remove unpacked deliveries @planningRoutes@onHandleUnpackedDeliveries',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onPrint(routeId) {
    this.routesService.printRoutes([routeId]);
  }

  onPrintLoadingSheet(routeId) {
    this.routesService.printLoadingSheet([routeId]);
  }

  onPrintBillOfLading(routeId) {
    this.routesService.onPrintBOL([routeId]);
  }

  onDownloadBillOfLading(routeId) {
    this.routesService.onDownloadBOL([routeId]);
  }

  onPrintIkea(route) {
    const serviceIds = _.uniq(route.routeTaskList.filter(t => t.taskType === 'Stopover').map(t => t.serviceId));
    this.$delivery.$asyncValues(serviceIds)
      .then((services) => {
        this.commonsDialogService.printIkea(services);
      })
  }

  onExportRoute(routeId) {
    this.routesService.exportRoutes(
      [routeId]);
  }

  onSortTypeChange(sortName) {
    const isSameSortName = !!this.selectedSortValue && _.isEqual(this.selectedSortValue.name, sortName);
    const newType = isSameSortName ? _.isEqual(this.selectedSortValue.type, SortType.asc) ? SortType.desc : SortType.asc : SortType.asc;

    this.selectedSortValue = {
      name: sortName,
      type: isSameSortName ? newType : SortType.asc,
      value: isSameSortName ? this.sortTypesValues[sortName][newType] : this.sortTypesValues[sortName].asc
    }

    // this._setTotals();
    this._getRoutes();
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getRoutes() {
    this.excludeMode = false;
    this.selectedIds = [];

    this.routesFacadeService.clearStore();
    this.routesFacadeService.getInfiniteScrollEntities(this._getRoutesQuery(), true);
  }

  private _getRoutesQuery() {
    const params = {
      ids: this.filterConfig.routeIds,
      expandServices: false,
      expandTasks: false,
      expandTasksExt: false,
      query: this.filterConfig.queryString,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      status: this.filterConfig.bringozFilters.routeStatuses,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      areaIds: this.filterConfig.bringozFilters.serviceAreaIds,
      agentIds: this.filterConfig.bringozFilters.agentIds,
      skill: this.filterConfig.bringozFilters.agentSkills,
      resourceIds: this.filterConfig.bringozFilters.resourceIds.concat(this.filterConfig.bringozFilters.agentScheduleIds),
      statusGroup: this.selectedGroup,
      tags: this.filterConfig.tags,
      limit: this.loadLimit,
      sort: _.get(this.selectedSortValue, 'value')
    }
    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);

    return params;
  }

  private _updateRoute(route) {
    this.routesService.updateRoute(route);
  }

  private _updateInternalTask(task, route) {
    this.tasksService.updateInternalTask(task);
  }


  private _reCreateRoute(route, resourceAllocation: ResourceAllocationTimeWindowExtModel, queries?: ChangeRouteResourceQueryModelModel) {
    this.leanPlanningService.recreateRoute(route.id, resourceAllocation.resourceAllocationId, resourceAllocation.id, "Allocation", resourceAllocation.id, queries)
  }

  private _updateStateParams() {
    this.$state.go('.', {
      routeIds: this.filterConfig.routeIds,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      groupIds: this.filterConfig.bringozFilters.groupIds,
      serviceAreaIds: this.filterConfig.bringozFilters.serviceAreaIds,
      agentIds: this.filterConfig.bringozFilters.agentIds,
      agentSkills: this.filterConfig.bringozFilters.agentSkills,
      resourceIds: this.filterConfig.bringozFilters.resourceIds,
      agentScheduleIds: this.filterConfig.bringozFilters.agentScheduleIds,
      routeStatuses: this.filterConfig.bringozFilters.routeStatuses,
      dateRangeTemplateType: this.filterConfig.bringozFilters.dateRangeTemplateType,
    }, {reload: false, notify: false});
  }


  private _addExpandedRoutes(routeIds) {
    this._getExpandedRoutes(routeIds);
  }


  private _removeExpandedRoutes(routeIds) {
    this.expandedRoutes = _.filter(this.expandedRoutes, function (expendedRoute) {
      return !_.includes(routeIds, expendedRoute.rid)
    });
    // this.expandedRoutesTasks = _.filter(this.expandedRoutesTasks, task => {
    //   return !_.includes(routeIds, task.routeId);
    // })
    const expandedRoutesTaskIdsToRemove = _.filter(this.expandedRoutesTasks, (task: TaskModel) => {
      return _.includes(routeIds, task.routeId);
    }).map(task => task.id);
    this.tasksFacadeService.removeByIds(expandedRoutesTaskIdsToRemove);
    this._setServiceAreaIds(this.expandedRoutes);
  }

  private _setServiceAreaIds(expandedRoutes) {
    const currentServiceAreaIds = _.map(this.expendedRoutesServiceAreas, 'areaId');
    const expendedRoutesServiceAreaIds = _.chain(expandedRoutes)
      .flatMap('serviceAreaIdList')
      .uniq()
      .value();

    const serviceAreaIdsToAdd = _.difference(expendedRoutesServiceAreaIds, currentServiceAreaIds);
    const serviceAreaIdsToRemove = _.difference(currentServiceAreaIds, expendedRoutesServiceAreaIds);

    if (serviceAreaIdsToRemove.length) {
      this.expendedRoutesServiceAreas = _.filter(this.expendedRoutesServiceAreas, function (s) {
        return !_.includes(serviceAreaIdsToRemove, s.areaId)
      })
    }

    if (serviceAreaIdsToAdd.length) {
      this._getServiceAreasByIds(serviceAreaIdsToAdd);
    }
  }

  private _getExpandedRoutes(routeIds) {
    this.routesService.getRoutes(routeIds, undefined, false)
      .then((expandedRoutes: any) => {
        const updatedExpendedRoutes = _.filter(this.expandedRoutes, (r) => {
          return !_.includes(routeIds, r.rid);
        });
        this.expandedRoutes = updatedExpendedRoutes.concat(expandedRoutes);
        this.tasksFacadeService.setMany(expandedRoutes[0].taskListExt);
        // this.routesFacadeService.setMany(expandedRoutes);
        // this.expandedRoutesTasks = this.expandedRoutesTasks.concat(expandedRoutes[0].taskListExt);
        this._setServiceAreaIds(this.expandedRoutes)
      })
  }

  private _getServiceAreasByIds(ids) {
    this.serviceAreasRef.$asyncValues(ids)
      .then((serviceAreas) => {
        this.expendedRoutesServiceAreas = _.uniqBy(this.expendedRoutesServiceAreas.concat(serviceAreas), 'areaId');

      })
  }

  private _setRange(range) {
    this.filterConfig.range = range;
    this._setTimeSelectModeByRange(range);
    this._updateStateParams();
  }

  private _setTimeSelectModeByRange(range) {
    const dateStart = this.moment(range.dateStart).format("MM/DD/YYYY"),
      dateEnd = this.moment(range.dateEnd).format("MM/DD/YYYY");
    // Disable TIME picker if its not the same date.
    this.timeSelectEnabled = _.isEqual(dateStart, dateEnd);
  }

  private _setTotals() {
    this.totals = undefined;
    this.routesService.getRoutesStatusesTotals(
      this.filterConfig.routeIds,
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.bringozFilters.branchIds,
      this.filterConfig.bringozFilters.serviceAreaIds,
      this.filterConfig.queryString,
      this.filterConfig.tags,
      this.filterConfig.bringozFilters.agentIds,
      this.filterConfig.bringozFilters.agentSkills,
      this.filterConfig.bringozFilters.resourceIds.concat(this.filterConfig.bringozFilters.agentScheduleIds),
      this.filterConfig.bringozFilters.routeStatuses
    ).then((totals) => {
      this.totals = totals;

      this.totalSelectedRoutesCount = !!this.filterConfig.bringozFilters.routeStatuses?.length ? _.reduce(this.filterConfig.bringozFilters.routeStatuses, (sum, n) => {
        return sum + (this.totals[n.toLowerCase()] || 0);
      }, 0) : this.totals.total;
    })
  }

  private _resetRoutes(ids, excludeMode) {
    this.loading = true;
    this.routeRequestsService.resetRoutes(
      excludeMode ? [] : ids,
      this.filterConfig.branchIds,
      excludeMode ? ids : [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      undefined,
      this.filterConfig.agentSkills,
      this.filterConfig.queryString,
      this.filterConfig.bringozFilters.serviceAreaIds,
      this.filterConfig.bringozFilters.routeStatuses,
      this.filterConfig.bringozFilters.resourceIds.concat(this.filterConfig.bringozFilters.agentScheduleIds),
      this.filterConfig.tags,
    )
      .then((updatedRoutes) => {
        if (updatedRoutes.length > 1) {
          this.leanPlanningAlertsService.resetManySuccess();
        } else {
          this.leanPlanningAlertsService.resetSuccess();
        }
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.resetManyError();
          this.$log.error('Failed to reset routes @planningRoutes@onResetRoutes',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }


  _deleteRoutes(ids, excludeMode) {
    this.loading = true;
    this.routeRequestsService.deleteRoutes(
      excludeMode ? [] : ids,
      this.filterConfig.branchIds,
      excludeMode ? ids : [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.bringozFilters.agentSkills,
      this.filterConfig.queryString,
      this.filterConfig.bringozFilters.serviceAreaIds,
      this.filterConfig.bringozFilters.routeStatuses,
      this.filterConfig.bringozFilters.resourceIds.concat(this.filterConfig.bringozFilters.agentScheduleIds),
      this.filterConfig.tags
    )
      .then((deletedRoutes) => {
        if (deletedRoutes.length > 1) {
          this.leanPlanningAlertsService.deleteManySuccess();
        } else {
          this.leanPlanningAlertsService.deleteOneSuccess();
        }
        this.filterConfig = angular.copy(this.filterConfig);
        this.resetSelection(ids);
        this._setTotals();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.deleteManyError();
        this.$log.error('Failed to delete routes @planningRoutes@onDeleteRoutes', error);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _updateBranchesRoutes(branchIdsPayload) {
    this.loading = true;
    this.routeRequestsService.updateBranch(
      this.excludeMode ? [] : this.selectedIds,
      branchIdsPayload,
      this.filterConfig.branchIds,
      this.excludeMode ? this.selectedIds : [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.agentSkills,
      this.filterConfig.queryString,
      this.filterConfig.bringozFilters.serviceAreaIds,
      this.filterConfig.bringozFilters.routeStatuses,
      this.filterConfig.bringozFilters.resourceIds.concat(this.filterConfig.bringozFilters.agentScheduleIds),
      this.filterConfig.tags
    )
      .then((updatedRoutes) => {
        this.leanPlanningAlertsService.updateSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error('Failed to update routes @planningRoutes@_updateBranchesRoutes',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _updateBranchesRoute(id, branchIdsPayload) {
    this.loading = true;
    this.routeRequestsService.updateBranch([id], branchIdsPayload)
      .then((updatedRoutes) => {
        this.leanPlanningAlertsService.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error('Failed to update routes @planningRoutes@_updateBranchesRoutes', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _assignAssistant(routeId: string, updatedAssistants: string[]) {
    this.routesService.assignAssistant(routeId, updatedAssistants)
      .then((updatedRoute) => {

      })
  }

  private _initPushesTimer() {
    this._destroyPushesTimer();

    this.pushesTimeoutRef = this.$timeout(() => {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;

      this.commonsDialogService.stillThereConfirm()
        .then((continueSession) => {
          if (continueSession) {
            this._initPushesTimer();

            //Sync Expanded Routes/Tasks
            if (this.expandedRoutes?.length) {
              this._getExpandedRoutes(_.map(this.expandedRoutes, 'id'));
            }

          }
        })
    }, (this.maxUserIdleTimeMinutes * 60000));
  }

  private _destroyPushesTimer() {
    if (this.pushesTimeoutRef) {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;
    }
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoutesTest', {
    bindings: {
      dateRangeTemplateType: '<?',
      ids: '<?',
      project: '<?',
      from: '<',
      to: '<',
      routeStatuses: '<',
      serviceAreaIds: '<',
      agentIds: '<?',
      agentSkills: '<?',
      resourceIds: '<?',
      agentScheduleIds: '<?',
      branchIds: '<',
      groupIds: '<?',
      groupsBranchIds: '<',
      branchMode: '<',
      selectedGroup: '<',
      selectedQuickFilterId: '<',
      serviceAreasMap: '<'
    },
    template: require('./planning-routes-test.html').default,
    controller: PlanningRoutesTestComponent
  });
